import { ReactNode } from 'react';
import { Stack, SxProps, Typography, useTheme } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export type TabOption = {
  label: string;
  value: string;
  icon?: ReactNode;
};

export type TabGroupProps = {
  selected?: string;
  options: TabOption[];
  onChange: (value: string) => void;
  sx?: SxProps;
};

export function TabGroup({ selected, options, onChange, sx = {} }: TabGroupProps) {
  const { palette } = useTheme();

  return (
    <ToggleButtonGroup
      exclusive
      onChange={(e, v) => onChange(v)}
      color="primary"
      sx={{
        p: '6px',
        gap: '10px',
        borderRadius: '12px',
        justifyContent: 'space-between',
        background: palette.background.paper,

        '& > .Mui-selected': {
          transition: 'background-color 0.3s ease-in-out !important',
          backgroundColor: `${palette.primary.main} !important`,
          color: `${palette.primary.contrastText} !important`,
        },
        ...sx,
      }}
    >
      {options.map((o) => (
        <ToggleButton
          key={o.value}
          value={o.value}
          selected={selected === o.value}
          data-treedistestid={`tab-${o.value.toLowerCase().replace(/\s+/g, '-')}`}
          sx={{
            border: 'none !important',
            borderRadius: '8px !important',
            minWidth: '100px',
            color: palette.grey[800],
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
            {o.icon}
            <Typography fontWeight={500} noWrap>
              {o.label}
            </Typography>
          </Stack>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
